import {EventTypes} from '@core/enums';

export class CalendarHelper {

  /**
   * returns event type
   * @param id - event type Id
   */
  public static eventTypeChanged(id: number): string {
    return EventTypes[id]?.toLowerCase()
  }
}

